import GreyBadgeWithIcon from "../reusableComponents/badgeWithIcon";
import Bar from "../reusableComponents/bar";
import GreyBadge from "../reusableComponents/greyBackgroundBadge";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import { formatDateLL } from "../../algorithms";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { customStyle } from "../../algorithms/styleDirection";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getEditDataProjectForm } from "../../API/store/actions/projects/projects";
import ModalComponent from "../reusableComponents/modal";
import EditProjectForm from "./editProject/editProjectForm";
import DeleteProcAlert from "../tasks/editProc.js/deleteProc";
import EditProjectStatus from "./editProjectStatus/projStatus";
import AddMilestone from "./addMilestone";
import AddTaskAttachments from "../tasks/addTaskAttachmentPopup";
import { useSelector } from "react-redux";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const ProjectCard = ({
  project,
  index,
  projAdded,
  setProjAdded,
  userToken,
  communityId,
  show,
  setshow,
  check,
}) => {
  // const [show, setshow] = useState({ id: null, display: false });
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [visibleProc, setVisibleProc] = useState(false);
  const [visibleStatus, setVisibleStatus] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [projectTitle, setProjectTitle] = useState(null);
  const community = useSelector((state) => state.community.communityId);

  const [showMilestonePopup, setShowMilestonePopup] = useState(false);

  const onShowMilestonePopup = () => {
    setShowMilestonePopup(true);
  };

  const renderMilestoneModal = () => {
    return (
      <AddMilestone
        projectId={projectId}
        setProjAdded={setProjAdded}
        projAdded={projAdded}
        show={showMilestonePopup}
        onHide={() => setShowMilestonePopup(false)}
      />
    );
  };

  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);

  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = () => {
    return (
      <AddTaskAttachments
        procAdded={projAdded}
        setProcAdded={setProjAdded}
        projectId={projectId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };

  const [data, setData] = useState(null);
  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menuProjectCard")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  return (
    <>
      <ModalComponent
        body={
          <EditProjectForm
            communityId={communityId}
            projectTitle={projectTitle}
            projectId={projectId}
            setVisible={setVisibleEdit}
            data={data?.data}
            setProjAdded={setProjAdded}
            projAdded={projAdded}
            userToken={userToken}
          />
        }
        hasImage={
          <img
            src="/assets/images/greeniconedit.svg"
            width={20}
            height={20}
            alt=""
          />
        }
        setModalVisible={setVisibleEdit}
        modalVisible={visibleEdit}
        size={"xl"}
        title={Lang.editProject}
      />
      <ModalComponent
        body={
          <DeleteProcAlert
            userToken={userToken}
            setProcAdded={setProjAdded}
            procAdded={projAdded}
            projectId={projectId}
            setVisible={setDeleteModalVisible}
            content={
              getDir(getCurrentLangFromRedux()) == "rtl"
                ? "هل تريد حذف المشروع والمراحل والأنشطة الملحقة ؟"
                : "Do you want to delete this Project, Milestones and Activities that depends on it ?"
            }
          />
        }
        size={"s"}
        modalVisible={deleteModalVisible}
        setModalVisible={setDeleteModalVisible}
        hasImage={
          <img
            src="/assets/images/deleteicon.png"
            width={20}
            height={20}
            alt=""
          />
        }
        title={
          getDir(getCurrentLangFromRedux()) == "rtl"
            ? "هل انت متاكد ؟"
            : "Are you sure ?"
        }
        background={"modalBackground mx-5"}
      />
      <ModalComponent
        body={
          <EditProjectStatus
            communityId={communityId}
            userToken={userToken}
            projectId={projectId}
            setVisible={setVisibleEdit}
            setProcAdded={setProjAdded}
            procAdded={projAdded}
          />
        }
        hasImage={
          <img
            src="/assets/images/icons/status.png"
            width={20}
            height={20}
            alt=""
          />
        }
        setModalVisible={setVisibleStatus}
        modalVisible={visibleStatus}
        size={"xl"}
        title={Lang.editStatus}
      />
      <div key={index} className="col-lg-6 col-12 mb-4">
        <div
          style={{
            border: "1px solid #C7C7C9",
            borderRadius: 5,
            height: "100%",
          }}
          className="me-2 ms-1 my-2 d-flex flex-column"
        >
          <div className="d-flex justify-content-around px-2 mt-2">
            <Link
              to={`/projectDetails/${project.id}`}
              className="col-11 px-2 text-black text-decoration-none"
              style={{ fontSize: 21 }}
            >
              {project.name}
            </Link>
            {/* {renderUL} */}
            <div className="col d-flex justify-content-end align-items-start btn-group">
              {check ? (
                <>
                  <div
                    style={{ display: show.display ? "block" : "none" }}
                    className={`${customStyle("arrow-horizontalProjectCard")} ${
                      show.display ? "show" : ""
                    }`}
                  ></div>
                  <ul
                    className={`${customStyle("dropdown-menuProjectCard")} ${
                      show.display ? "show" : ""
                    }`}
                    style={{
                      display: show.display ? "block" : "none",
                    }}
                  >
                    <li
                      style={{ cursor: "pointer" }}
                      id={project.id}
                      onClick={(e) => {
                        const currentId = e.currentTarget.id;
                        resolver(
                          getEditDataProjectForm,
                          setData,
                          currentId,
                          communityId,
                          userToken
                        );
                        setProjectId(currentId);
                      }}
                    >
                      <span
                        className={`dropdown-item ${customStyle(
                          "dropdown-item"
                        )}`}
                      >
                        {Lang.editProject}
                      </span>
                    </li>
                    <li style={{ cursor: "pointer" }}>
                      <span
                        onClick={() => {
                          setProjectId(project.id);
                          setProjectTitle(project.name);
                          setVisibleStatus(true);
                        }}
                        className={`dropdown-item ${customStyle(
                          "dropdown-item"
                        )}`}
                      >
                        {Lang.editStatus}
                      </span>
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      id={project.id}
                      onClick={(e) => {
                        const currentId = e.currentTarget.id;
                        setProjectId(currentId);
                        onShowAttachments();
                      }}
                    >
                      <span
                        className={`dropdown-item ${customStyle(
                          "dropdown-item"
                        )}`}
                      >
                        {Lang.addAttachments}
                      </span>
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      id={project.id}
                      onClick={(e) => {
                        const currentId = e.currentTarget.id;
                        setProjectId(currentId);
                        onShowMilestonePopup();
                      }}
                    >
                      <span
                        className={`dropdown-item ${customStyle(
                          "dropdown-item"
                        )}`}
                      >
                        {Lang.addMilestone}
                      </span>
                    </li>
                    <li
                      style={{ cursor: "pointer" }}
                      id={project.id}
                      onClick={(e) => {
                        const currentId = e.currentTarget.id;
                        setProjectId(currentId);
                        setDeleteModalVisible(true);
                      }}
                    >
                      <span
                        className={`dropdown-item ${customStyle(
                          "dropdown-item"
                        )}`}
                      >
                        {Lang.deleteProject}
                      </span>
                    </li>
                  </ul>
                </>
              ) : null}
            </div>

            {community?.adminProject && (
              <Icon
                id={project.id}
                name="ellipsis-v"
                size={18}
                className="icon"
                onclick={(e) => {
                  const id = e.currentTarget.id;
                  id == null
                    ? setshow({
                        id,
                        display: true,
                      })
                    : id == show.id
                    ? setshow({
                        id: null,
                        display: false,
                      })
                    : setshow({
                        id,
                        display: true,
                      });
                }}
              />
            )}
          </div>
          <div
            style={{ fontSize: 14, color: "#444444" }}
            className="px-3 my-1 mb-3"
          >
            {Lang.inPeriod}
            <span>
              &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
              {`${formatDateLL(project.startDate)}`}
            </span>{" "}
            <span>
              &nbsp;&nbsp;&nbsp;{Lang.to} {`${formatDateLL(project.endDate)}`}
            </span>
          </div>

          <div className="my-3 d-flex  justify-content-lg-around align-items-center  justify-content-center px-xl-3 px-lg-1 px-3">
            <div className="col-6 my-lg-0 my-2">
              <Bar
                barColor={"#D3D3D3"}
                textColor={"#1A73E8"}
                backgroundColor={"#F2F2F2"}
                precentage={project?.percentage}
                width={90}
                height={38}
                containerStyle={"col-12"}
                finished={project?.activitiesDoneCount}
                total={project?.activitiesCount}
              />
            </div>

            {project.projectStatus != null ? (
              <div className="col-6 my-lg-0 my-2">
                <GreyBadgeWithIcon
                  containerStyle={"col-12"}
                  describtion={project.projectStatus}
                />
              </div>
            ) : null}
          </div>
          <div className="d-flex d-lg-none d-xl-flex justify-content-around mb-4 px-4 pb-3 col-12 m-auto">
            <GreyBadge
              containerStyle={"col-4 mx-1"}
              describtion={Lang.milestones}
              count={project?.milestonesCount}
            />
            <GreyBadge
              containerStyle={"col-4 mx-1"}
              describtion={Lang.activities}
              count={project?.activitiesCount}
            />
            <GreyBadge
              containerStyle={"col-4 mx-1"}
              describtion={Lang.Members}
              count={project?.membersCount}
            />
          </div>

          <div
            className="d-flex flex-column h-100 px-3 py-3"
            style={{
              borderTopLeftRadius: 3,
              borderTopRightRadius: 3,
              borderBottomLeftRadius: 5,
              borderBottomRightRadius: 5,
              backgroundColor: "rgb(242, 242, 242)",
              color: "#444444",
            }}
          >
            {project.lastActivity ? (
              <>
                <div className="justify-content-between d-flex align-items-center ">
                  <div style={{ color: "#1A73E8" }}> {Lang.lastActivity} </div>
                  <div style={{ color: "#707070" }}>
                    {formatDateLL(project.lastActivity?.startDate)}
                  </div>
                </div>
                <div className=" ">{project.lastActivity?.name}</div>
                {/* <div>Attachment</div> */}
                {/* <AttachmentCard fileName={"FileName"} /> */}
              </>
            ) : (
              <div className="px-3 py-3 text-center">
                {Lang.noActivitiesYet}
              </div>
            )}
          </div>
        </div>
      </div>
      {renderMilestoneModal()}
      {renderAttachmentsModal()}
    </>
  );
};

export default ProjectCard;
